(function () {
  "use strict";

  /*
    Luxx Cosmetic Domain Picker v3

    Market mapping:
    - dk  = luxxcosmetic.dk  = Denmark / DKK
    - com = luxxcosmetic.com = International / EUR

    Final behavior:
    - Before visitor choice:
      Use Shopify geo/localization suggestion first.
      This means Danish visitors on .com can still see the DK suggestion.

    - After visitor choice:
      Respect saved choice / selected Shopify country.
      This prevents the popup from returning after the user selects Finland, Austria, etc.
      in the Shopify country selector.

    - No forced redirect.
    - Full query-string preservation for tracking.
    - iPhone-friendly custom in-modal selector.
  */

  var PASS_PARAM = "luxx_store";
  var FORCE_PARAM = "show_domain_picker";

  var CHOICE_TTL_DAYS = 180;
  var SNOOZE_TTL_DAYS = 7;

  var CHOICE_TTL_MS = CHOICE_TTL_DAYS * 24 * 60 * 60 * 1000;
  var SNOOZE_TTL_MS = SNOOZE_TTL_DAYS * 24 * 60 * 60 * 1000;

  var KEY_CHOICE = "luxxcosmetic_domain_choice_v2";
  var KEY_SNOOZE = "luxxcosmetic_domain_snooze_v2";

  var SHOW_DELAY_MS = 900;

  var selectedStoreKey = "com";

  var STORES = {
    dk: {
      key: "dk",
      country: "DK",
      host: "luxxcosmetic.dk",
      origin: "https://luxxcosmetic.dk"
    },
    com: {
      key: "com",
      country: "INT",
      host: "luxxcosmetic.com",
      origin: "https://luxxcosmetic.com"
    }
  };

  function setWithExpiry(key, value, ttlMs) {
    try {
      localStorage.setItem(
        key,
        JSON.stringify({
          v: value,
          exp: Date.now() + ttlMs
        })
      );
    } catch (e) {}
  }

  function getWithExpiry(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;

      var obj = JSON.parse(raw);

      if (!obj || typeof obj.exp !== "number") {
        localStorage.removeItem(key);
        return null;
      }

      if (Date.now() > obj.exp) {
        localStorage.removeItem(key);
        return null;
      }

      return obj.v;
    } catch (e) {
      return null;
    }
  }

  function removeKey(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  }

  function normalizePath(path) {
    if (!path) return "/";
    return path.charAt(0) === "/" ? path : "/" + path;
  }

  function getHost() {
    return (window.location.hostname || "")
      .toLowerCase()
      .replace(/^www\./, "");
  }

  function getCurrentStoreKey() {
    var host = getHost();

    if (host === STORES.dk.host || host.endsWith("." + STORES.dk.host)) {
      return "dk";
    }

    if (host === STORES.com.host || host.endsWith("." + STORES.com.host)) {
      return "com";
    }

    return null;
  }

  function getStoreKeyForCountry(countryCode) {
    var country = (countryCode || "").toUpperCase();

    if (country === "DK") {
      return "dk";
    }

    return "com";
  }

  function getBrowserLangPrimary() {
    var lang = "";

    if (navigator.languages && navigator.languages.length) {
      lang = navigator.languages[0];
    } else {
      lang = navigator.language || navigator.userLanguage || "";
    }

    lang = (lang || "").toLowerCase();

    return lang.split("-")[0] || "";
  }

  function getPopupLanguage(currentStoreKey) {
    var lang = getBrowserLangPrimary();

    /*
      Recommended behavior:
      - .dk always Danish
      - .com Danish only if browser is Danish
      - otherwise English/default
    */
    if (currentStoreKey === "dk") {
      return "da";
    }

    return lang === "da" ? "da" : "en";
  }

  function isLikelyBot() {
    var ua = (navigator.userAgent || "").toLowerCase();

    return /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|facebookexternalhit|twitterbot|pinterest|crawler|spider|bot|lighthouse|pagespeed|chrome-lighthouse/i.test(
      ua
    );
  }

  function shouldBlockOnThisPage() {
    var path = (window.location.pathname || "/").toLowerCase();
    var host = getHost();

    if (path === "/cart" || path.indexOf("/cart/") === 0) return true;
    if (path === "/checkout" || path.indexOf("/checkout/") === 0) return true;
    if (path.indexOf("/checkouts") === 0) return true;
    if (path === "/account" || path.indexOf("/account/") === 0) return true;
    if (path === "/challenge" || path.indexOf("/challenge/") === 0) return true;

    if (host.indexOf("checkout.") === 0) return true;
    if (host.indexOf("checkout") !== -1 && host.indexOf("shopify") !== -1) {
      return true;
    }

    return false;
  }

  function runWhenIdle(fn) {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(fn, { timeout: 1800 });
    } else {
      setTimeout(fn, SHOW_DELAY_MS);
    }
  }

  function getI18nValue(i18n, key, lang) {
    if (!i18n) return "";

    var suffix = lang === "da" ? "-da" : "";
    var value = i18n.getAttribute("data-" + key + suffix);

    if (!value) {
      value = i18n.getAttribute("data-" + key);
    }

    return value || "";
  }

  function updateFlag(storeKey) {
    var flag = document.getElementById("domainPickFlag");
    if (!flag) return;

    if (storeKey === "dk") {
      flag.innerHTML =
        '<svg width="42" height="32" viewBox="0 0 37 28" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
        '<rect width="37" height="28" fill="#C60C30"/>' +
        '<rect x="12" width="4" height="28" fill="#fff"/>' +
        '<rect y="12" width="37" height="4" fill="#fff"/>' +
        "</svg>";
      return;
    }

    flag.textContent = "🌍";
  }

  function applyPopupLanguage(lang) {
    var i18n = document.getElementById("domainPickI18n");
    if (!i18n) return;

    var titleEl = document.getElementById("domainPickTitle");
    var descEl = document.getElementById("domainPickDesc");
    var noteEl = document.getElementById("domainPickNote");
    var fieldLabelEl = document.getElementById("domainPickFieldLabel");
    var submitEl = document.getElementById("domainPickSubmit");
    var dismissEl = document.getElementById("domainPickDismiss");
    var dkOptionLabelEl = document.getElementById("domainPickOptionDKLabel");
    var comOptionLabelEl = document.getElementById("domainPickOptionCOMLabel");

    if (titleEl) titleEl.textContent = getI18nValue(i18n, "title", lang);
    if (descEl) descEl.textContent = getI18nValue(i18n, "desc", lang);
    if (noteEl) noteEl.textContent = getI18nValue(i18n, "note", lang);
    if (fieldLabelEl) fieldLabelEl.textContent = getI18nValue(i18n, "label-country", lang);
    if (submitEl) submitEl.textContent = getI18nValue(i18n, "submit", lang);
    if (dismissEl) dismissEl.textContent = getI18nValue(i18n, "dismiss", lang);

    if (dkOptionLabelEl) {
      dkOptionLabelEl.textContent = getI18nValue(i18n, "option-dk", lang);
    }

    if (comOptionLabelEl) {
      comOptionLabelEl.textContent = getI18nValue(i18n, "option-com", lang);
    }
  }

  function setSelectedStore(storeKey) {
    var validStoreKey = STORES[storeKey] ? storeKey : "com";
    var options = document.querySelectorAll(".domain-pick-option[data-store]");

    selectedStoreKey = validStoreKey;

    options.forEach(function (option) {
      var isSelected = option.getAttribute("data-store") === validStoreKey;

      option.classList.toggle("is-selected", isSelected);
      option.setAttribute("aria-checked", isSelected ? "true" : "false");
    });

    updateFlag(validStoreKey);
  }

  function show(overlay, targetStoreKey) {
    if (!overlay) return;

    var currentStoreKey = getCurrentStoreKey();
    var preferredStoreKey = targetStoreKey || currentStoreKey || "com";

    applyPopupLanguage(getPopupLanguage(currentStoreKey));
    setSelectedStore(preferredStoreKey);

    overlay.style.display = "flex";
    overlay.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("domain-pick-open");

    var selectedOption = overlay.querySelector(".domain-pick-option.is-selected");

    if (selectedOption && typeof selectedOption.focus === "function") {
      setTimeout(function () {
        try {
          selectedOption.focus({ preventScroll: true });
        } catch (e) {
          selectedOption.focus();
        }
      }, 50);
    }
  }

  function hide(overlay) {
    if (!overlay) return;

    overlay.style.display = "none";
    overlay.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("domain-pick-open");
  }

  function buildUrl(storeKey, path) {
    var store = STORES[storeKey];
    if (!store) return null;

    var current = new URL(window.location.href);
    var target = new URL(store.origin + normalizePath(path));

    /*
      Preserve full query string for attribution:
      gclid, gbraid, wbraid, fbclid, ttclid, msclkid, utm_*, _gl,
      affiliate/referral parameters, etc.

      Only remove our debug force parameter so testing URLs do not keep reopening
      the popup after redirect.
    */
    current.searchParams.forEach(function (value, key) {
      if (key === FORCE_PARAM) return;
      target.searchParams.append(key, value);
    });

    target.searchParams.set(PASS_PARAM, storeKey);
    target.hash = current.hash || "";

    return target.toString();
  }

  function captureChoiceFromUrl() {
    var url = new URL(window.location.href);
    var value = url.searchParams.get(PASS_PARAM);

    if (value && STORES[value]) {
      setWithExpiry(KEY_CHOICE, value, CHOICE_TTL_MS);
      removeKey(KEY_SNOOZE);

      url.searchParams.delete(PASS_PARAM);
      window.history.replaceState({}, "", url.toString());

      return value;
    }

    return null;
  }

  function getSelectedStorefrontCountry(overlay) {
    var country = "";

    /*
      Comes from snippets/domain-picker.liquid:
      data-current-country="{{ localization.country.iso_code | default: '' | escape }}"
    */
    if (overlay) {
      country = overlay.getAttribute("data-current-country") || "";
    }

    if (!country) {
      try {
        if (window.Shopify && window.Shopify.country) {
          country = window.Shopify.country;
        }
      } catch (e) {}
    }

    return (country || "").toUpperCase();
  }

  function getShopifyDetectedCountry() {
    var root = "/";

    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        root = window.Shopify.routes.root;
      }
    } catch (e) {}

    var currentCountry = "";

    try {
      if (window.Shopify && window.Shopify.country) {
        currentCountry = window.Shopify.country;
      }
    } catch (e) {}

    var url =
      root.replace(/\/?$/, "/") +
      "browsing_context_suggestions.json?country[enabled]=true";

    if (currentCountry) {
      url += "&country[exclude]=" + encodeURIComponent(currentCountry);
    }

    return fetch(url, {
      method: "GET",
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Localization detection failed");
        }

        return response.json();
      })
      .then(function (data) {
        var detected =
          data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle;

        if (detected) {
          return String(detected).toUpperCase();
        }

        var suggestion =
          data &&
          data.suggestions &&
          data.suggestions[0] &&
          data.suggestions[0].parts &&
          data.suggestions[0].parts.country &&
          data.suggestions[0].parts.country.handle;

        if (suggestion) {
          return String(suggestion).toUpperCase();
        }

        return "";
      })
      .catch(function () {
        return "";
      });
  }

  function fallbackCountryBeforeChoice() {
    /*
      Before the visitor has made a choice, do NOT use Shopify's selected
      storefront country as fallback, because it can be a default EU market
      country like AT/FI and suppress the DK suggestion on .com.

      Use only browser language as weak fallback.
    */
    if (getBrowserLangPrimary() === "da") {
      return "DK";
    }

    return "";
  }

  function shouldAutoShow(
    currentStoreKey,
    targetStoreKey,
    choice,
    snoozed,
    handedOff,
    targetSource
  ) {
    if (handedOff) return false;
    if (snoozed) return false;
    if (!currentStoreKey || !targetStoreKey) return false;

    /*
      If current domain already matches target market,
      do not show popup.
    */
    if (currentStoreKey === targetStoreKey) return false;

    /*
      After explicit visitor choice:
      selected_country is allowed to win.
    */
    if (targetSource === "selected_country_after_choice") {
      return true;
    }

    /*
      Before choice / geo suggestion:
      if visitor is already on the store they previously chose,
      do not annoy them.
    */
    if (choice && STORES[choice] && currentStoreKey === choice) {
      return false;
    }

    return true;
  }

  function bindSubmit(overlay) {
    var button = document.getElementById("domainPickSubmit");
    var options = document.querySelectorAll(".domain-pick-option[data-store]");

    if (!button || !options.length) return;

    options.forEach(function (option) {
      option.addEventListener("click", function () {
        var storeKey = option.getAttribute("data-store");
        setSelectedStore(storeKey);
      });

      option.addEventListener("keydown", function (event) {
        if (
          event.key !== "ArrowDown" &&
          event.key !== "ArrowUp" &&
          event.key !== "ArrowLeft" &&
          event.key !== "ArrowRight" &&
          event.key !== "Enter" &&
          event.key !== " "
        ) {
          return;
        }

        event.preventDefault();

        if (event.key === "Enter" || event.key === " ") {
          setSelectedStore(option.getAttribute("data-store"));
          return;
        }

        var nextStoreKey =
          option.getAttribute("data-store") === "dk" ? "com" : "dk";

        var nextOption = document.querySelector(
          '.domain-pick-option[data-store="' + nextStoreKey + '"]'
        );

        setSelectedStore(nextStoreKey);

        if (nextOption && typeof nextOption.focus === "function") {
          nextOption.focus();
        }
      });
    });

    button.addEventListener("click", function () {
      var storeKey = selectedStoreKey;
      var currentStoreKey = getCurrentStoreKey();
      var path = window.location.pathname || "/";
      var targetUrl = buildUrl(storeKey, path);

      if (!STORES[storeKey]) return;

      setWithExpiry(KEY_CHOICE, storeKey, CHOICE_TTL_MS);
      removeKey(KEY_SNOOZE);

      if (currentStoreKey === storeKey) {
        hide(overlay);
        return;
      }

      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });
  }

  function bindManualOpen(overlay) {
    document.addEventListener("click", function (event) {
      var target = event.target;

      if (!target || typeof target.closest !== "function") return;

      var link = target.closest(
        'a[href="/pages/change-store"], a[href^="/pages/change-store?"]'
      );

      if (!link) return;

      event.preventDefault();
      show(overlay, null);
    });
  }

  function bindDismiss(overlay) {
    var dismiss = document.getElementById("domainPickDismiss");

    if (dismiss) {
      dismiss.addEventListener("click", function () {
        setWithExpiry(KEY_SNOOZE, "1", SNOOZE_TTL_MS);
        hide(overlay);
      });
    }

    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) {
        setWithExpiry(KEY_SNOOZE, "1", SNOOZE_TTL_MS);
        hide(overlay);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        overlay.getAttribute("aria-hidden") === "false"
      ) {
        setWithExpiry(KEY_SNOOZE, "1", SNOOZE_TTL_MS);
        hide(overlay);
      }
    });
  }

  function init() {
    if (isLikelyBot()) return;
    if (shouldBlockOnThisPage()) return;

    var overlay = document.getElementById("domainPickOverlay");
    if (!overlay) return;

    var handedOff = captureChoiceFromUrl();
    var choice = getWithExpiry(KEY_CHOICE);
    var snoozed = getWithExpiry(KEY_SNOOZE);

    var currentStoreKey = getCurrentStoreKey();

    var isChangeStorePage =
      window.location.pathname.indexOf("/pages/change-store") !== -1;

    var forceShow =
      window.location.search.indexOf(FORCE_PARAM + "=1") !== -1;

    bindSubmit(overlay);
    bindManualOpen(overlay);
    bindDismiss(overlay);

    if (isChangeStorePage || forceShow) {
      show(overlay, choice || currentStoreKey || "com");
      return;
    }

    runWhenIdle(function () {
      /*
        Visitor has made a choice if:
        - they have a saved picker choice
        - they arrived with luxx_store handoff
        - they clicked Not now
      */
      var visitorHasMadeChoice = Boolean(choice || handedOff || snoozed);

      /*
        AFTER choice:
        Shopify selected storefront country is allowed to win.
        This prevents the popup from returning after the customer selects
        Finland, Austria, etc. in the Shopify country selector.
      */
      if (visitorHasMadeChoice) {
        var selectedCountry = getSelectedStorefrontCountry(overlay);

        if (selectedCountry) {
          var selectedTargetStoreKey = getStoreKeyForCountry(selectedCountry);

          if (
            shouldAutoShow(
              currentStoreKey,
              selectedTargetStoreKey,
              choice,
              snoozed,
              handedOff,
              "selected_country_after_choice"
            )
          ) {
            show(overlay, selectedTargetStoreKey);
          }

          return;
        }
      }

      /*
        BEFORE choice:
        Do not let Shopify's default selected country suppress the popup.
        Use Shopify localization/geolocation suggestion instead.
      */
      getShopifyDetectedCountry().then(function (country) {
        if (!country) {
          country = fallbackCountryBeforeChoice();
        }

        var targetStoreKey = getStoreKeyForCountry(country);

        if (
          shouldAutoShow(
            currentStoreKey,
            targetStoreKey,
            choice,
            snoozed,
            handedOff,
            "geo_suggestion_before_choice"
          )
        ) {
          show(overlay, targetStoreKey);
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();